import { panelInformation } from "../../../DataFiles/panelInformation";
import {
  isImageInsideObstacle,
  isPositionFree,
  canPlaceImage,
} from "../canvasFunction";
import { calculateCarportStructure } from "./doubleCarportPlacement";
import { getPixelsPerMeter } from "./smithStructure";

export const singleCarportPlacement = ({
  roofDetail,
  roofInfo,
  structureItem,
  dispatch,
  abstacles,
  gridInfo,
  limitCapacity,
  quantityInfo,
}) => {
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  sessionStorage.setItem("structureItem", JSON.stringify(structureItem));

  let pixelMultiple = getPixelsPerMeter(roofInfo);

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  const imgSrc = structureItem.structureImgSrc;
  const imgDimension = {
    height: (2 * panel.height + 0.025) * pixelMultiple,
    width: (4 * panel.width + 0.025) * pixelMultiple,
    gap: (rowDistance / 1000) * pixelMultiple,
  };

  const newImages = [];
  const polygonCoordinates = roofPolygons[quantityInfo.roofNo].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x + 0,
    point.y + 0,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const angleDegrees = 0;
  let x = minX + pixelMultiple * 0.305;
  let y = minY + pixelMultiple * 0.305;
  let row = 0;
  let isFirstRowPlaced = false;
  let updateCondition = true;
  while (y <= maxY) {
    while (x <= maxX) {
      if (limitCapacity !== 0 && newImages.length > limitCapacity) {
        updateCondition = false;
      }
      if (
        updateCondition &&
        canPlaceImage(
          x,
          y,
          imgDimension.height,
          imgDimension.width,
          polygonCoordinates,
          angleDegrees
        ) &&
        isPositionFree(
          x,
          y,
          imgDimension.height,
          imgDimension.width,
          newImages
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.height,
          imgDimension.width,
          abstacles
        )
      ) {
        const imageId =
          Number(Math.floor(Math.random() * 499)) *
          Number(Math.floor(Math.random() * 499));
        const newImage = {
          id: imageId,
          src: imgSrc,
          x: x,
          y: y,
          width: imgDimension.height,
          height: imgDimension.width,
          type: structureItem.name,
          angleDegree: 0,
        };
        newImages.push(newImage);
        x += imgDimension.height;
      } else {
        x += 1;
      }
    }
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      y += imgDimension.width + imgDimension.gap;
    }
    row++;
    x = minX + pixelMultiple * 0.305;
  }

  calculateCarportStructure({
    newImages,
    structureItem,
    dispatch,
    quantityInfo,
    roofDetail,
    roofInfo,
  });
};
